export const actions = {
  async nuxtServerInit (_, ctx) {
    try {
      await Promise.all([
        ctx.$authNew.fetchSites(),
        ctx.$static.fetchTree({ isPage: true, sort: 'ASC' }),
        ctx.$currencies.fetchByOffices({ save: true }),
        ctx.$configProvider.fetch()
      ])
    } catch (error) {
      console.error(error)
    }
  }
}
